<template>
  <div style="transform: none;">
    <el-input
      class="Input"
      :value="value"
      @input="onChange($event)"
      maxlength="1"
    >
      <el-button
        slot="append"
        icon="el-icon-edit"
        @click="onClickDraw()"
      ></el-button>
    </el-input>

    <el-dialog
      class="Dialog"
      title="手書き文字入力"
      :visible.sync="isActive"
      width="70%"
    >
      <div class="EditorContainer">
        <MyScriptEditor1Char
          v-if="isActive"
          @onClose="isActive = false"
          @onSelect="onSelect($event)"
        ></MyScriptEditor1Char>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyScriptEditor1Char from "./MyScriptEditor1Char";

export default {
  components: {
    MyScriptEditor1Char,
  },
  name: "MyScriptJSVueComponent",
  props: {
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    onChangeInput: {
      type: Function,
      default: () => {},
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      isActive: false,
    };
  },
  created () {},

  methods: {
    onChange ($event) {
      this.$emit("onChangeInput", $event);
    },
    onClickDraw () {
      this.isActive = true;
    },
    onSelect ($event) {
      this.$emit("onSubmit", $event);
    },
  },
  mounted () {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import url("../../node_modules/myscript/dist/myscript.min.css");

::v-deep .el-dialog__body {
  padding: 0 20px !important;
}

.Input {
  width: 105px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: $turquoise-base;
}
.writing-container {
  height: 400px;
  width: 100%;
  border: 1px solid $--border-color-lighter;
  margin-top: 10px;
  margin-left: auto;
}
.Guides {
  position: absolute;
  height: 360px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 80px;
  grid-template-rows: repeat(4, 118px);
}
.Guide {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed $--border-color-light;
  margin: auto;
}

.Guide::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 80%;
  top: 10px;
  left: 50%;
  border-right: 1px dashed $--border-color-light;
}

.Guide::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px;
  top: 50%;
  left: 10px;
  border-top: 1px dashed $--border-color-light;
}

.text {
  font-style: bold;
  font-weight: 800;
  color: red;
  font-size: 100;
  line-height: 2;
}
.Header {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  background: $background-gray-light; // #f6f6fa;
}
.Candidates {
  height: 80px;
}
.CandidatesSelect {
  margin-top: 10px;
  width: 80px;
}
.CharacterSubmit {
  margin-top: 10px;
  width: 100%;
}
// .Container {
// }
.Dialog {
  user-select: none;
}
</style>
